(async () => {

  if (!customElements.get('iframe-section')) {
    class IframeSection extends HTMLElement {
      constructor() {
        super();

        this.url = new URL(this.dataset.url);
        this.newUrl = '';
        this.sqzlId = '';

        // create the iframe element
        const iframe = document.createElement('iframe');

        // add basic styling
        iframe.style.border = 'none';

        // check & set the sqzl id
        const cookies = document.cookie.split(';');
        const sqzlCookie = cookies.filter(cookie => cookie.includes('sqzllocal'));

        sqzlCookie[0] ? this.sqzlId = sqzlCookie[0].split('sqzllocal=')[1] : null;

        // if sqzlId exists create the new url
        if(this.sqzlId != '') {
          this.url.searchParams.set('sqzl', this.sqzlId);
          this.url.search = this.url.searchParams.toString();
          this.newUrl = this.url.toString();

          iframe.setAttribute('src', this.newUrl);
          this.appendChild(iframe);
        } else {
          iframe.setAttribute('src', this.url);
          this.appendChild(iframe);
        }

      }
    }

    window.iframeSection = IframeSection;
    customElements.define('iframe-section', IframeSection);
  }

})();
